<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Apply Bank Account') }}</h3>
                <span class="fz-16 fw-400">{{ $t('Create an account tailored to your needs') }}</span>
            </div>

            <step-container
                :current_step="3"
                :step_list="stepList"
            ></step-container>
        </div>
        <b-container fluid class="mt-0 pb-5">
            <div id="body-container">
                <b-row>
                    <b-col xl="12">
                        <div class="p-0" v-if="init">
                            <DirectorInfo
                                ref='directorInfo'
                                :information = information
                                :account_id = account_id
                                :user_no = user_no
                                @on-error = "onError"
                                @file-uploaded = "fileUploaded"
                                :doc_type_list = document
                            ></DirectorInfo>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="d-flex">
                        <router-link to="/hongkong-registered-address" class="btn btn-previous d-block mr-auto" tag="button">{{ $t('Previous') }}</router-link>
                        <button @click="nextStep" class="ml-auto btn btn-primary d-block">{{ $t('Next Step') }}</button>
                    </b-col>
                </b-row>
            </div>
      </b-container>
      <LoaderComponent v-if="isLoading || (isLoading === false && init === false)"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
    import DirectorInfo from '@/components/CardManagement/directorInfo';
    import CreateAccount from '@/services/CreateAccount';
    import Account from "@/services/Account";
  
    export default {
        name: 'hongkong-director-info',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                init : false,
                account_id : '',
                user_no : '',
                information : '',
                stepList:["Basic Information","Registered Address", "Director Info","Beneficiary Info"],
                document:[
                    {
                        "id":2,
                        "name":"Passport"
                    },
                    {
                        "id":3,
                        "name":"Hong Kong Permanent ID Card"
                    },
                    {
                        "id":4,
                        "name":"Hong Kong ID Card"
                    }
                ]
            }
        },
        components: {
            LoaderComponent,
            stepContainer,
            DirectorInfo
        },
        methods:{
            nextStep(){
                this.isLoading = true;
                console.log("=== click next step ====")
                if(this.$refs['directorInfo'].validate()){
                    this.$refs['directorInfo'].uploadFile(this.account_id,this.user_no);
                }
                else{
                    this.isLoading = false;
                }
            },
            checkError(err){
                let self = this;
                try{
                    this.isLoading = false;
                    const response = err.response;  
                    if(response.status == 400){
                        console.log(response.data);
                        if(typeof response.data.message === 'string'){
                            this.$swal({
                                icon: 'info',
                                html:response.data.message,
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                        else{
                            if(response.data.message['errorMsg']){
                                this.$swal({
                                    icon: 'info',
                                    html:response.data.message['errorMsg'],
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                            }
                            else{
                                let ret = [];
                                let directorInfo = this.$refs['directorInfo'];

                                Object.keys(response.data.message).forEach((key) => {
                                    let error = response.data.message[key][0];
                                    if(typeof directorInfo.error[key] !== "undefined"){
                                        directorInfo.error[key] = error;
                                    }
                                    
                                    if(key!="accountId"){
                                        ret.push(error);
                                    }
                                });

                                this.$swal({
                                    icon: 'info',
                                    html:ret.join("<br>"),
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                            }
                        }
                    }      
                    else if(response.status == 401 && response.data.name == "Unauthorized"){
                            localStorage.removeItem("token");
                            localStorage.removeItem("member");
                            localStorage.removeItem("isFirstTime");
                            this.$router.push({ 
                                path: '/login', 
                            });
                    }
                    else{
                        if(localStorage.getItem("token")){
                            var msg = (response.data)?response.data.message:err.message;
                            this.$notify({
                                type: 'warn',
                                text: msg
                            })
                        }
                    }
                }catch(e){
                    console.log(err);
                }
            },
            onError(){
                this.isLoading = false;
            },
            fileUploaded(){
                
                let director_info = this.$refs['directorInfo'];

                let params = {
                    "accountId":this.account_id,
                    "userNo":""+this.user_no,
                    "directorName":director_info.params.directorName,
                    "directorBirthDate":director_info.params.directorBirthDate,
                    "directorIdNo":director_info.params.directorIdNo,
                    "directorIdType":director_info.params.directorIdType,
                    "directorIdFront":director_info.file.directorIdFront,
                    "directorIdReverse":director_info.file.directorIdReverse,
                    "directorIdHold":director_info.file.directorIdHold,
                    "directorCertExpiryDate":director_info.params.directorCertExpiryDate,
                    "directorCountryCode":"HKG",
                    "directorProvince":director_info.params.directorProvince,
                    "directorCity":director_info.params.directorCity,
                    "directorArea":director_info.params.directorArea,
                    "directorAddress":director_info.params.directorAddress,
                };

                Account.updateHongkong(params).then(response => {
                    const data = response.data.data;
                    this.isLoading = false;
                    this.$router.push({ 
                        name: 'hongkong-beneficiary-information'
                    });
                }).catch(err => {
                    this.checkError(err);
                });
            }
        },
        mounted() {
            this.init = false;
            this.$nextTick(() => {
                CreateAccount.list({start:0, length:-1}).then((response)=>{
                    if (response.status == 200) {
                        if(response.data.data.length>0){
                            this.account_id = response.data.data[0]['id'];
                            this.user_no = response.data.data[0]['userNo'];
                            this.information = response.data.data[0]['information'];
                        }
                        this.init = true;
                    }
                });
            });
        },
    };
  </script>